import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import currency from 'currency.js';

import { ProductEnum } from '../../../../modules/authentication/models/product.enum';
import { CurrencyJsPipe } from '../../../../modules/pipes/currency-js.pipe';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { ThemesService } from '../../../../services/themes.service';

@Component({
  selector: 'app-dashboard-advance-block',
  templateUrl: './dashboard-advance-block.component.html',
  styleUrls: ['./dashboard-advance-block.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressBarModule,
    LocalisePipe,
    CurrencyJsPipe,
  ],
})
export class DashboardAdvanceBlockComponent {
  @Output()
  transferMoney = new EventEmitter<void>();

  @Output()
  addDeal = new EventEmitter<void>();

  @Input()
  public limit: number;

  @Input()
  public percentageUsed: number;

  @Input()
  public availableBalance: currency;

  @Input()
  public balance: currency;

  @Input()
  public isPaymentPastDue: boolean;

  @Input()
  public isDarkTheme: boolean;

  @Input()
  public productPayment = false;

  @ViewChild('confirmAddDeal') confirmAddDeal: TemplateRef<any>;

  constructor(
    private dialog: MatDialog,
    public themesService: ThemesService,
  ) {}

  public openConfirmModal(): void {
    this.dialog.open(this.confirmAddDeal, {
      width: '692px',
      autoFocus: false,
      panelClass: this.themesService.getDarkThemeClass(),
      backdropClass: this.themesService.getDarkThemeClass(),
    });
  }
}
